import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.is-finite";
import "core-js/modules/es.number.is-nan";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*  eslint-disable no-use-before-define */
export function isAbsent(value) {
  return !isDefined(value) || isNull(value) || Number.isNaN(value);
}
var BLANK_REGEX = /^\s*$/;
export function isBlank(value) {
  return isAbsent(value) || typeof value === 'string' && BLANK_REGEX.test(value);
}
export function isDefined(value) {
  return value !== undefined;
}
export function isEmpty(value) {
  if (!isObject(value)) {
    return isAbsent(value) || value === '';
  }

  for (var prop in value) {
    // eslint-disable-line
    return false;
  }

  return true;
}
export function isNull(value) {
  return value === null;
}
export function isNumber(value) {
  return !Number.isNaN(value) && Number.isFinite(value);
}
export function isObject(value) {
  var type = _typeof(value);

  return !isNull(value) && (type === 'object' || type === 'function');
}
export function isPresent(value) {
  return isDefined(value) && !isNull(value) && !Number.isNaN(value);
}